module.exports = __webpack_public_path__ + "static/media/2.02f8d5e7.jpg";